import { useEffect, useState } from "react";
import VisitsService from "../../../services/VisitsService";
import { isSet } from "../../../utils/commonUtils";
import Buttons from "../../../components/UI/Buttons";
import Icons from "../../../components/UI/Icons";

const FutureAppointments = (props) => {
  const [appintments, setAppointments] = useState([]);
  // const {employee_id}=props;
  useEffect(() => {
    const getFutureAppointments = async () => {
      const response = await VisitsService.getFutureDateAppointments();
      if (response) {
        setAppointments(response);
      }
    };
    getFutureAppointments();
  }, [props.calendarRecords]);
  // console.log('appointments',appintments);

  return (
    <div className="sh_cardBox h-auto sh_widgets sh_labdetailwidget">
      <div className="sh_cardHeader">
        <div className="form-group d-flex mb-0 justify-content-between align-items-center">
          <h6
            className="text-md font-weight-bold mb-0"
            style={{ color: "#1d2d44" }}
          >
            {/* <span className="px-2">
                        <Buttons
                        iconType='WhiteBoard'
                        iconSize={14}
                        iconColor={"#1d2d44"}
                        />
                        </span> */}
            Upcoming Schedule
          </h6>
          {appintments.length > 0 && (
            <span className="badge badge-primary ml-2">
              {appintments.length}
            </span>
          )}
        </div>
      </div>
      <div
        style={{ overflowX: "auto" }}
        className="sh_cardBody p-0 px-2 sh_widget_ht"
      >
        <table className="table sh_tablenew table-hover nowrap my-0 table-striped ">
          <thead>
            <tr>
              {/* <th scope="col">Patient Name</th>
              <th scope="col">Appointment Time</th> */}
              <th scope="col">Name</th>
              <th scope="col">Time</th>
            </tr>
          </thead>
          <tbody
            data-rbd-droppable-id="waiting"
            data-rbd-droppable-context-id="2"
          >
            {isSet(appintments, []).length === 0 && (
              <tr>
                <td colspan="2" className="sh_nodatatd">
                  <div className="d-flex w-100 align-items-center justify-content-center flex-column">
                    <span>
                      {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.0001 16.001H9.49211C8.73611 16.001 8.00811 16.287 7.45311 16.8L7.38911 16.86C7.03711 17.186 6.76311 17.586 6.58511 18.032L6.23511 18.911" stroke="#94A0B8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M13.1859 13.1859C14.5309 12.7009 15.4999 11.4349 15.4999 9.92092C15.4999 7.98792 13.9329 6.41992 11.9989 6.41992C10.4849 6.41992 9.21889 7.38892 8.73389 8.73492" stroke="#94A0B8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M3.96009 7.96094C2.26509 11.3349 2.81909 15.5499 5.63509 18.3659C8.45209 21.1829 12.6681 21.7359 16.0421 20.0399" stroke="#94A0B8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M5.63403 5.63505V5.63505C9.15003 2.11905 14.85 2.11905 18.365 5.63505C21.88 9.15005 21.88 14.849 18.366 18.365" stroke="#94A0B8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M20 20L4 4" stroke="#94A0B8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg> */}
                      <Icons type="NoRecords" />
                    </span>
                    <div className="sh_nodata"> No record found </div>
                  </div>
                </td>
              </tr>
            )}
            {isSet(appintments, []).map((itm, ind) => {
              return (
                <>
                  <tr
                    key={ind}
                    data-rbd-draggable-context-id="2"
                    data-rbd-draggable-id="waiting-0"
                    tabindex="0"
                    role="button"
                    aria-describedby="rbd-hidden-text-2-hidden-text-8"
                    data-rbd-drag-handle-draggable-id="waiting-0"
                    data-rbd-drag-handle-context-id="2"
                    draggable="false"
                  >
                   <td style={{ color: "#174ADD" }}>
                    {itm.employee.first_name} {itm.employee.last_name}
                   </td>
                   <td>{itm.visit_time}</td>
                  </tr>
                </>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default FutureAppointments;
